const TEST_STRING = '00test00';
let hasFormTest = false;
export const detectFormTest = (data) => {
    if (hasFormTest) {
        return true;
    }
    for (const key in data) {
        if (typeof data[key] === 'string' && data[key].toLowerCase().includes(TEST_STRING)) {
            return (hasFormTest = true);
        }
    }
    return false;
};
export const findTestFormField = () => {
    const allFormInputs = document.querySelectorAll('input[type="text"]');
    for (let formInput of allFormInputs) {
        if (formInput.value.toLowerCase().includes(TEST_STRING)) {
            return formInput;
        }
    }
    return null;
};
